export default __webpack_public_path__ + "static/media/02-Haitham-AL-Hammadi.31567bd9.png";